import React from 'react';
import { Transition, animated } from 'react-spring/renderprops.cjs';
import RoundedModal from 'components/Global/RoundedModal/RoundedModal.jsx';
import ContentSplitModal from '../ContentSplitModal/ContentSplitModal.jsx';
import modalsCopy from './modalsCopy.js';

const pageStyle = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  position: 'absolute',
  zIndex: 0,
  backfaceVisibility: 'hidden',
};

class OnboardingModal extends React.Component {
  constructor() {
    super();
    this.state = {
      current: 0,
    };
  }

  next() {
    const { current } = this.state;
    if (current + 1 < modalsCopy.length) {
      this.setState({ current: current + 1 });
    } else {
      this.props.close();
    }
  }

  render() {
    const { close, isOpen } = this.props;
    const { current } = this.state;

    const pages = modalsCopy.map((page, i) => style =>
      <animated.div style={{ ...style, ...pageStyle, zIndex: i }}>
        <ContentSplitModal
          onClick={() => this.next(i)}
          isOpen={isOpen}
          title={page.title}
          content={page.content}
          image={page.image}
          imagePosition={page.imagePosition}
          imageSize={page.imageSize}
          btnText={page.btnText}
        />
      </animated.div>);

    return (
      <RoundedModal close={close} isOpen={isOpen}>
        <Transition
          native
          reset
          unique
          items={current}
          initial={{ opacity: 1, transform: 'translate3d(0%,0,0)' }}
          from={{ opacity: 0, transform: 'translate3d(5%,0,0)' }}
          enter={{ opacity: 1, transform: 'translate3d(0%,0,0)' }}
          leave={{ opacity: 0, transform: 'translate3d(-5%,0,0)' }}
        >
          {i => pages[i]}
        </Transition>
      </RoundedModal>
    );
  }
}

export default OnboardingModal;
